<script setup lang="ts">
import { RouterView } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'
</script>

<template>
  <Box class="auth-layout">
    <RouterView />
  </Box>
</template>

<style scoped>
.auth-layout {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}
</style>
